import { render, staticRenderFns } from "./ManuscriptInfo.vue?vue&type=template&id=65ce77c2&scoped=true"
import script from "./ManuscriptInfo.vue?vue&type=script&lang=js"
export * from "./ManuscriptInfo.vue?vue&type=script&lang=js"
import style0 from "./ManuscriptInfo.vue?vue&type=style&index=0&id=65ce77c2&prod&lang=css"
import style1 from "./ManuscriptInfo.vue?vue&type=style&index=1&id=65ce77c2&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "65ce77c2",
  null
  
)

export default component.exports